import { Tag } from '@bedrock/components'
import React from 'react'

/**
 * 是否独家达人
 */
const ExclusiveExpertCell = ({
  value = undefined,
  record,
}: {
  value?: boolean;
  record?: any;
}) => {
  if (!record?.demand_source_kol_content_vo?.is_exclusive_supplier && value === undefined) {
    return '--'
  }
  if (Number(record?.demand_source_kol_content_vo?.is_exclusive_supplier) === 1 || value === true) {
    return <Tag color='light-green' text='是' size='small' />
  }
  return <Tag color='light-grey' text='否' size='small' />
}

export default ExclusiveExpertCell
